import * as tslib_1 from "tslib";
export function paramsMap(params) {
    return Object.keys(params).reduce(function (parsedObj, item) {
        var _a;
        return tslib_1.__assign({}, parsedObj, (_a = {}, _a[item.replace('amp;', '')] = params[item], _a));
    }, {});
}
